import React, { ReactElement } from "react"
import { Amount } from "@ssc-booking/api-contracts"
import * as O from "fp-ts/Option"
import ReceiptRow from "./ReceiptRow"
import {
    isBulletRow,
    isLabelRow,
    isPaxRow,
    ReceiptRow as _ReceiptRow,
    ReceiptRowBullet,
    ReceiptRowDataLabel,
    ReceiptRowPax,
} from "./types"
import { formatPromotionalAmount } from "./helpers/utils"
type Props = {
    totalAmount: O.Option<Amount>
    isPromotional: boolean
    label: string | ReactElement
    rows: readonly (_ReceiptRow | ReceiptRowDataLabel)[]
    note?: string | JSX.Element
}

const ReceiptSection: React.FC<React.PropsWithChildren<Props>> = ({
    totalAmount,
    isPromotional,
    label,
    note,
    rows,
}) => (
    <tbody>
        <ReceiptRow
            variant="title"
            label={label}
            note={note}
            isPromotional={isPromotional}
            value={formatPromotionalAmount(totalAmount)}
        />

        {rows.map((row) => {
            if (isBulletRow(row)) return <ReceiptBulletRow key={row.label} {...row} />
            if (isLabelRow(row)) return <ReceiptLabelRow key={row.label} {...row} />
            if (isPaxRow(row)) return <ReceiptPaxRow key={row.label} {...row} />
        })}
    </tbody>
)

const ReceiptBulletRow: React.FC<ReceiptRowBullet> = (row) => (
    <React.Fragment>
        <ReceiptRow variant="detail" {...row} withDot={true} value={formatPromotionalAmount(row.amount)} />
        {row.rows.map((r) => (
            <ReceiptPaxRow key={r.label} {...r} tabbed />
        ))}
    </React.Fragment>
)

const ReceiptLabelRow: React.FC<ReceiptRowDataLabel> = (row) => (
    <ReceiptRow variant="detail" {...row} value={undefined} />
)

const ReceiptPaxRow: React.FC<ReceiptRowPax & { tabbed?: boolean }> = ({ tabbed = false, ...row }) => (
    <ReceiptRow variant="detail" {...row} value={formatPromotionalAmount(row.amount)} tabbed={tabbed} />
)

export default ReceiptSection
